import { ReactNode } from "react";
import {
	normalizeStatusKey,
	normalizeStatusLabel,
} from "../../../../../../shared/utils/normalize-status-label";

export interface AccountSelectItem {
	key: string;
	node: ReactNode;
}

/*
	Собирает список уникальных статусов для CompactSelect в том же стиле, что и в компонентах.
	- data: массив объектов
	- keyName: название поля со статусом (например, 'campaign_status' или 'status')
	- setState: функция обновления состояния (setAccountSelectItems)
*/
export const buildSelectStatuses = (
	data: any[] | undefined,
	keyName: string,
	setState: (items: AccountSelectItem[]) => void,
) => {
	if (!data || data.length === 0) {
		setState([{ key: "all", node: <span>Всі статуси</span> }]);
		return;
	}

	const statuses: AccountSelectItem[] = [
		{ key: "all", node: <span>Всі статуси</span> },
	];

	data.forEach((item) => {
		const raw = item?.[keyName] ?? "";
		const normKey = normalizeStatusKey(raw);

		if (!normKey) return;

		const found = statuses.find((s) => s.key === normKey);
		if (!found) {
			const statusItem: AccountSelectItem = {
				key: normKey,
				node: <span>{normalizeStatusLabel(raw)}</span>,
			};
			statuses.push(statusItem);
		}
	});

	setState(statuses);
};
